//import React, { Component } from "react"
import React from "react"
//import ReactDOM from "react-dom"
import { Log } from "../lib/logger"

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props)
        this.state = {hasError: false }
    }

    componentDidCatch(error, info) {
        this.setState({hasError: true })
        try {
            Log().error(`${error.message} - ${info.componentStack}`)
        } catch(e) {
            // NOOP
        }
    }

    render() {
        if (this.state.hasError) {
            return <h1>Oops!!! Something went wrong</h1>
        } else {
            return this.props.children
        }
    }
} 

export default ErrorBoundary


// WEBPACK FOOTER //
// ./src/components/ErrorBoundary.jsx